import React from "react";
import LoadingL from "../assets/lotties/Loader.json";
import Lottie from "lottie-react";

function Loader() {
  return (
    <div id="overlayAllJd">
      <div id="loaderPos">
        <Lottie animationData={LoadingL} loop style={{width: "80px"}} />
      </div>
    </div>
  );
}

export default Loader;
